export default __webpack_public_path__ + "static/telemedicine-app-development-company-peerbits-f93f8b8458a53464fba67b73ac3da07c.png";